<template>
<div>
    <h2>{{ $t("userStatisticsView.title") }}</h2>
    <table>
        <thead>
            <tr>
                <th>{{ $t("userStatisticsView.event") }}</th>
                <th>{{ $t("userStatisticsView.paidSum") }}</th>
                <th>{{ $t("userStatisticsView.estimated") }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="e in store.events" :key="e.eventId">
                <td>{{ e.name }}</td>
                <td>{{ getSponsorsPaymentSum(e.sponsors) }}</td>
                <td>{{ getSponsorsEstimatedPayment(e.sponsors) }}</td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script lang="ts">
import axios from "axios";
import {store, Organization, Sponsor, ParticipationStatus} from "store";
import {isNotificationAllowed} from "common";
import {defineComponent} from "vue";

export default defineComponent({
    mounted() {
        this.setTitle();
    },
    data() {
        const allOrganizations: Organization[] = [];
        const pendingAmount: number = undefined;
        const paidAmount: number = undefined;
        const sponsors: Sponsor[] = [];

        return {
            store: store,
            sponsors,
            paidAmount,
            pendingAmount,
            remindersSent: false,
            allOrganizations,
            isNotificationAllowed: isNotificationAllowed
        };
    },
    methods: {
        setTitle() {
            store.page.showTopNav = true;
        },
        getSponsorsPaymentSum(sponsors: Sponsor[]): number {
            let sum = sponsors
                .filter(s => s.participationStatus == "Paid")
                .reduce((sum, sponsor) => sum + sponsor.paid, 0);
            return sum;
        },
        getSponsorsEstimatedPayment(sponsors: Sponsor[]): number {
            let sum = sponsors
                .filter(s => s.participationStatus == "Participates" || s.participationStatus == "Paid")
                .reduce((sum, sponsor) => sum + sponsor.estimatedPayment, 0);
            return sum;
        },
        sponsorsOfStatus(status: ParticipationStatus): Sponsor[] {
            return this.sponsors.filter(s => s.participationStatus == status);
        },
        async remindPendingPaymentSponsors() {
            try {
                for (let sponsor of this.sponsorsOfStatus("Participates")) {
                    if (isNotificationAllowed(sponsor)) {
                        await axios.post("sponsors/reminder-email", sponsor);

                        // note: sponsor.notificationSentOn will be slightly out of sync with actual
                        // notificationSentOn stored in db until store is reloaded
                        sponsor.notificationSentOn = new Date(Date.now());
                    }
                }
                this.remindersSent = true;
            } catch(e) {
                // TODO: Handle error
            }
        }
    }
})
</script>